import {
  TJobValuesOverlay, TOverlayBucketSize,
} from '../interface/job-values.ts';

const overlayOptions: Record<TJobValuesOverlay, string> = {
  shewhart: 'Shewhart',
  distribution: 'Dystrybucja',
  average: 'Przeciętny',
  median: 'Mediana',
  nothing: 'Bez nakładki',
};

const overlayBucketSizeOptions: Record<TOverlayBucketSize, string> = {
  total: 'Łącznie',
  year: 'Rok',
  quarter: 'Kwartał',
  month: 'Miesiąc',
  week: 'Tydzień',
};

export default {
  rollingAverageSize: 'Średnia wielkość ruchoma',
  showRollingAverage: 'Średnia ruchoma',
  selectOverlay: 'Narzuta',
  showOverlayLabel: 'Etykieta',
  overlayBucketSize: 'Okno czasowe',
  overlayOptions,
  overlayBucketSizeOptions,
};
